import { registerEditorContribution } from '../../../browser/editorExtensions.js';
import { MiddleScrollController } from './middleScrollController.js';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
registerEditorContribution(MiddleScrollController.ID, MiddleScrollController, 2 /* EditorContributionInstantiation.BeforeFirstInteraction */);
